// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  -webkit-tap-highlight-color: transparent;
}

.schedule-view-dialog {
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 100dvh);
  width: 100%;
  max-width: 500px;
  min-height: 0;
  background: #ffffff !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden !important;
  text-align: left;
  margin: 0 !important;
  padding: 0 !important;
}
.schedule-view-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px 20px;
  background: #ffffff !important;
  color: #1a1a1a;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 12px 12px 0 0 !important;
  flex-shrink: 0;
}
.schedule-view-dialog .dialog-header .dialog-title {
  margin: 0;
  padding: 0;
  font-size: clamp(16px, 4.2vw, 20px);
  font-weight: 600;
  line-height: 1.3;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
}
.schedule-view-dialog .dialog-header .header-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #5ea1d8;
  flex-shrink: 0;
}
.schedule-view-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
  --mat-mdc-button-persistent-ripple-color: transparent;
  --mat-mdc-button-ripple-color: transparent;
}
.schedule-view-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
}
.schedule-view-dialog .dialog-header .close-button mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.schedule-view-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 16px 12px;
  -webkit-overflow-scrolling: touch;
}
.schedule-view-dialog .dialog-content .lead {
  margin: 0 0 10px 0;
  font-size: 14px;
  line-height: 1.45;
  color: #666;
}
.schedule-view-dialog .dialog-content .content-title-block {
  margin-bottom: 14px;
  padding: 12px 14px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}
.schedule-view-dialog .dialog-content .content-title-block h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
}
.schedule-view-dialog .dialog-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 12px;
  margin-bottom: 14px;
}
.schedule-view-dialog .dialog-content .form-grid .full-width {
  width: 100%;
}
.schedule-view-dialog .dialog-content .form-grid .span-2 {
  grid-column: 1/-1;
}
.schedule-view-dialog .dialog-content .form-grid ::ng-deep {
  /* overflow must stay visible so the floating label can rise above the border */
}
.schedule-view-dialog .dialog-content .form-grid ::ng-deep .mat-mdc-text-field-wrapper,
.schedule-view-dialog .dialog-content .form-grid ::ng-deep .mdc-text-field,
.schedule-view-dialog .dialog-content .form-grid ::ng-deep .mdc-text-field--outlined {
  overflow: visible !important;
  border-radius: 4px !important;
}
.schedule-view-dialog .dialog-content .form-grid ::ng-deep .mdc-text-field--outlined .mdc-notched-outline__leading {
  border-radius: 4px 0 0 4px !important;
}
.schedule-view-dialog .dialog-content .form-grid ::ng-deep .mdc-text-field--outlined .mdc-notched-outline__trailing {
  border-radius: 0 4px 4px 0 !important;
}
.schedule-view-dialog .dialog-content .calendar-section-label {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
}
.schedule-view-dialog .dialog-content .calendar-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.schedule-view-dialog .dialog-content .calendar-option {
  width: 100%;
  min-height: 52px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  cursor: pointer;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.schedule-view-dialog .dialog-content .calendar-option:active {
  background: #f3f4f6;
}
.schedule-view-dialog .dialog-content .calendar-option.active {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
  background: #f6fbff;
}
.schedule-view-dialog .dialog-content .calendar-option:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}
.schedule-view-dialog .dialog-content .calendar-option-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.schedule-view-dialog .dialog-content .calendar-label {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}
.schedule-view-dialog .dialog-content .calendar-sublabel {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
}
.schedule-view-dialog .dialog-content .check-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: transparent;
  visibility: hidden;
  transition: color 0.15s ease, visibility 0.15s ease;
}
.schedule-view-dialog .dialog-content .check-icon.visible {
  color: #5ea1d8;
  visibility: visible;
}
.schedule-view-dialog .dialog-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: stretch;
  gap: 12px;
  padding: 14px 16px 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom, 0));
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  flex-shrink: 0;
  border-radius: 0 0 12px 12px !important;
}
.schedule-view-dialog .dialog-actions .cancel-btn,
.schedule-view-dialog .dialog-actions .primary-btn {
  flex: 1 1 0;
  min-width: 0;
  min-height: 44px;
  height: 44px;
  margin: 0;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}
.schedule-view-dialog .dialog-actions .cancel-btn mat-icon,
.schedule-view-dialog .dialog-actions .primary-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.schedule-view-dialog .dialog-actions .cancel-btn {
  background: white;
  color: #666;
  border: 1px solid #e0e0e0;
}
.schedule-view-dialog .dialog-actions .cancel-btn:hover {
  background: #f5f5f5;
  border-color: #ccc;
}
.schedule-view-dialog .dialog-actions .primary-btn {
  background-color: #5ea1d8 !important;
  color: #fff !important;
}
.schedule-view-dialog .dialog-actions .primary-btn:hover {
  filter: brightness(0.95);
}
.schedule-view-dialog .dialog-actions ::ng-deep .mat-mdc-button-base {
  height: 44px !important;
  min-height: 44px !important;
  max-height: 44px !important;
  padding: 0 14px !important;
  margin: 0 !important;
  box-sizing: border-box;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.schedule-view-dialog .dialog-actions ::ng-deep .mat-mdc-button-base .mdc-button__label {
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px;
  line-height: 1;
}

.calendar-logo {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.calendar-logo-inline {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  object-fit: contain;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .schedule-view-dialog {
    max-width: calc(100vw - 24px);
  }
  .schedule-view-dialog .dialog-header {
    padding: 14px 12px 14px 16px;
  }
  .schedule-view-dialog .dialog-content {
    padding: 14px 14px 10px;
  }
  .schedule-view-dialog .dialog-content .form-grid {
    grid-template-columns: 1fr;
  }
  .schedule-view-dialog .dialog-content .form-grid .span-2 {
    grid-column: 1;
  }
  .schedule-view-dialog .dialog-actions {
    padding: 12px 14px 14px;
    padding-bottom: max(14px, env(safe-area-inset-bottom, 0));
  }
}
@media (max-width: 480px) {
  .schedule-view-dialog {
    max-width: calc(100vw - 16px);
  }
  .schedule-view-dialog .dialog-header {
    padding: 12px 8px 12px 14px;
  }
  .schedule-view-dialog .dialog-content {
    padding: 12px 12px 8px;
  }
  .schedule-view-dialog .dialog-actions {
    padding: 12px 12px 14px;
    padding-bottom: max(14px, env(safe-area-inset-bottom, 0));
    gap: 10px;
  }
}
:host-context(body.theme-dark) {
  /* ── mat-form-field outlined inputs — transparent fill so the dark bg
     doesn't overflow the rounded outline border in dark mode ── */
}
:host-context(body.theme-dark) .schedule-view-dialog,
:host-context(body.theme-dark) .schedule-view-dialog .dialog-header,
:host-context(body.theme-dark) .schedule-view-dialog .dialog-content,
:host-context(body.theme-dark) .schedule-view-dialog .dialog-actions {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .schedule-view-dialog .dialog-actions {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .schedule-view-dialog .dialog-title,
:host-context(body.theme-dark) .schedule-view-dialog .lead,
:host-context(body.theme-dark) .schedule-view-dialog .calendar-section-label,
:host-context(body.theme-dark) .schedule-view-dialog .calendar-label,
:host-context(body.theme-dark) .schedule-view-dialog .calendar-sublabel,
:host-context(body.theme-dark) .schedule-view-dialog .close-button,
:host-context(body.theme-dark) .schedule-view-dialog .close-button mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .schedule-view-dialog .content-title-block,
:host-context(body.theme-dark) .schedule-view-dialog .calendar-option {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .schedule-view-dialog .calendar-option:active,
:host-context(body.theme-dark) .schedule-view-dialog .calendar-option.active {
  background: #273449 !important;
}
:host-context(body.theme-dark) .schedule-view-dialog .cancel-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled),
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-form-field,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-form-field-infix,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-form-field-flex {
  background: transparent !important;
  background-color: transparent !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog input,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-input-element,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field__input {
  background: transparent !important;
  background-color: transparent !important;
  color: #f1f5f9 !important;
  caret-color: #f1f5f9 !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-floating-label,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-floating-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mdc-floating-label--float-above,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-floating-label--float-above {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog input::placeholder,
:host-context(body.theme-dark) ::ng-deep .schedule-view-dialog .mat-mdc-input-element::placeholder {
  color: #64748b !important;
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/schedule-view-dialog/schedule-view-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA,wCAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,2BAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;EACA,uCAAA;EACA,cAAA;AAEJ;AAAI;EACE,SAAA;EACA,UAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAEN;AACI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACN;AAEI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,0CAAA;AAAN;AAEM;EACE,mBAAA;EACA,cAAA;AAAR;AAGM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AADR;AAME;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iCAAA;AAJJ;AAMI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAJN;AAOI;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AALN;AAOM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AALR;AASI;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AAPN;AASM;EACE,WAAA;AAPR;AAUM;EACE,iBAAA;AARR;AAWM;EACE,+EAAA;AATR;AAUQ;;;EAGE,4BAAA;EACA,6BAAA;AARV;AAWQ;EACE,qCAAA;AATV;AAYQ;EACE,qCAAA;AAVV;AAeI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAbN;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAdN;AAiBI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,wCAAA;EACA,uFAAA;AAfN;AAkBM;EACE,mBAAA;AAhBR;AAmBM;EACE,qBAAA;EACA,8CAAA;EACA,mBAAA;AAjBR;AAoBM;EACE,0BAAA;EACA,mBAAA;AAlBR;AAsBI;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArBN;AAwBI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAtBN;AAyBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;AAvBN;AAyBM;EACE,cAAA;EACA,mBAAA;AAvBR;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,SAAA;EACA,uBAAA;EACA,yDAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,uCAAA;AA1BJ;AA4BI;;EAEE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;AA1BN;AA4BM;;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzBR;AA6BI;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;AA3BN;AA6BM;EACE,mBAAA;EACA,kBAAA;AA3BR;AA+BI;EACE,oCAAA;EACA,sBAAA;AA7BN;AA+BM;EACE,wBAAA;AA7BR;AAiCI;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;AA/BN;AAkCI;EACE,+BAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;AAhCN;;AAqCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAlCF;;AAqCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;AAlCF;;AAqCA;EACE;IACE,6BAAA;EAlCF;EAoCE;IACE,4BAAA;EAlCJ;EAqCE;IACE,uBAAA;EAnCJ;EAqCI;IACE,0BAAA;EAnCN;EAqCM;IACE,cAAA;EAnCR;EAwCE;IACE,uBAAA;IACA,yDAAA;EAtCJ;AACF;AA0CA;EACE;IACE,6BAAA;EAxCF;EA0CE;IACE,2BAAA;EAxCJ;EA2CE;IACE,sBAAA;EAzCJ;EA4CE;IACE,uBAAA;IACA,yDAAA;IACA,SAAA;EA1CJ;AACF;AA8CA;EAyCE;kEAAA;AAnFF;AA2CE;;;;EAIE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAzCJ;AA4CE;EACE,8BAAA;AA1CJ;AA6CE;;;;;;;EAOE,yBAAA;AA3CJ;AA8CE;;EAEE,8BAAA;EACA,kDAAA;AA5CJ;AA+CE;;EAEE,8BAAA;AA7CJ;AAgDE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA9CJ;AAmDE;;;;;;EAME,kCAAA;EACA,wCAAA;AAjDJ;AAoDE;;;EAGE,kCAAA;EACA,wCAAA;EACA,yBAAA;EACA,+BAAA;AAlDJ;AAqDE;;;EAGE,kDAAA;AAnDJ;AAsDE;;EAEE,yBAAA;AApDJ;AAuDE;;EAEE,yBAAA;AArDJ;AAwDE;;EAEE,yBAAA;EACA,qBAAA;AAtDJ","sourcesContent":[":host {\n  display: block;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.schedule-view-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: min(90vh, 100dvh);\n  width: 100%;\n  max-width: 500px;\n  min-height: 0;\n  background: #ffffff !important;\n  border-radius: 12px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden !important;\n  text-align: left;\n  margin: 0 !important;\n  padding: 0 !important;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 16px 16px 20px;\n    background: #ffffff !important;\n    color: #1a1a1a;\n    border-bottom: 1px solid #e0e0e0;\n    border-radius: 12px 12px 0 0 !important;\n    flex-shrink: 0;\n\n    .dialog-title {\n      margin: 0;\n      padding: 0;\n      font-size: clamp(16px, 4.2vw, 20px);\n      font-weight: 600;\n      line-height: 1.3;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      border: none;\n    }\n\n    .header-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      color: #5ea1d8;\n      flex-shrink: 0;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 44px;\n      height: 44px;\n      min-width: 44px;\n      min-height: 44px;\n      border-radius: 50%;\n      flex-shrink: 0;\n      --mat-mdc-button-persistent-ripple-color: transparent;\n      --mat-mdc-button-ripple-color: transparent;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n      }\n\n      mat-icon {\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 16px 16px 12px;\n    -webkit-overflow-scrolling: touch;\n\n    .lead {\n      margin: 0 0 10px 0;\n      font-size: 14px;\n      line-height: 1.45;\n      color: #666;\n    }\n\n    .content-title-block {\n      margin-bottom: 14px;\n      padding: 12px 14px;\n      background: #f8f9fa;\n      border: 1px solid #e9ecef;\n      border-radius: 8px;\n\n      h3 {\n        margin: 0;\n        font-size: 15px;\n        font-weight: 600;\n        color: #333;\n        line-height: 1.4;\n        word-break: break-word;\n      }\n    }\n\n    .form-grid {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 10px 12px;\n      margin-bottom: 14px;\n\n      .full-width {\n        width: 100%;\n      }\n\n      .span-2 {\n        grid-column: 1 / -1;\n      }\n\n      ::ng-deep {\n        /* overflow must stay visible so the floating label can rise above the border */\n        .mat-mdc-text-field-wrapper,\n        .mdc-text-field,\n        .mdc-text-field--outlined {\n          overflow: visible !important;\n          border-radius: 4px !important;\n        }\n\n        .mdc-text-field--outlined .mdc-notched-outline__leading {\n          border-radius: 4px 0 0 4px !important;\n        }\n\n        .mdc-text-field--outlined .mdc-notched-outline__trailing {\n          border-radius: 0 4px 4px 0 !important;\n        }\n      }\n    }\n\n    .calendar-section-label {\n      margin: 0 0 8px 0;\n      font-size: 13px;\n      font-weight: 600;\n      color: #4b5563;\n    }\n\n    .calendar-options {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n    }\n\n    .calendar-option {\n      width: 100%;\n      min-height: 52px;\n      border: 1px solid #d1d5db;\n      border-radius: 10px;\n      background: #fff;\n      padding: 12px 14px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      text-align: left;\n      cursor: pointer;\n      box-sizing: border-box;\n      -webkit-tap-highlight-color: transparent;\n      transition: border-color 0.15s ease, background-color 0.15s ease,\n        box-shadow 0.15s ease;\n\n      &:active {\n        background: #f3f4f6;\n      }\n\n      &.active {\n        border-color: #5ea1d8;\n        box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n        background: #f6fbff;\n      }\n\n      &:focus-visible {\n        outline: 2px solid #5ea1d8;\n        outline-offset: 2px;\n      }\n    }\n\n    .calendar-option-text {\n      flex: 1 1 auto;\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n    }\n\n    .calendar-label {\n      font-size: 15px;\n      font-weight: 600;\n      color: #1f2937;\n      line-height: 1.3;\n    }\n\n    .calendar-sublabel {\n      font-size: 12px;\n      color: #6b7280;\n      line-height: 1.3;\n    }\n\n    .check-icon {\n      flex-shrink: 0;\n      width: 24px;\n      height: 24px;\n      font-size: 24px;\n      color: transparent;\n      visibility: hidden;\n      transition: color 0.15s ease, visibility 0.15s ease;\n\n      &.visible {\n        color: #5ea1d8;\n        visibility: visible;\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    justify-content: stretch;\n    gap: 12px;\n    padding: 14px 16px 16px;\n    padding-bottom: max(16px, env(safe-area-inset-bottom, 0));\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    flex-shrink: 0;\n    border-radius: 0 0 12px 12px !important;\n\n    .cancel-btn,\n    .primary-btn {\n      flex: 1 1 0;\n      min-width: 0;\n      min-height: 44px;\n      height: 44px;\n      margin: 0;\n      border-radius: 8px;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 1;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      box-sizing: border-box;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        flex-shrink: 0;\n      }\n    }\n\n    .cancel-btn {\n      background: white;\n      color: #666;\n      border: 1px solid #e0e0e0;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n    }\n\n    .primary-btn {\n      background-color: #5ea1d8 !important;\n      color: #fff !important;\n\n      &:hover {\n        filter: brightness(0.95);\n      }\n    }\n\n    ::ng-deep .mat-mdc-button-base {\n      height: 44px !important;\n      min-height: 44px !important;\n      max-height: 44px !important;\n      padding: 0 14px !important;\n      margin: 0 !important;\n      box-sizing: border-box;\n      display: inline-flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n    }\n\n    ::ng-deep .mat-mdc-button-base .mdc-button__label {\n      display: inline-flex !important;\n      align-items: center !important;\n      gap: 8px;\n      line-height: 1;\n    }\n  }\n}\n\n.calendar-logo {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  object-fit: contain;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.calendar-logo-inline {\n  width: 22px;\n  height: 22px;\n  border-radius: 5px;\n  object-fit: contain;\n  background: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .schedule-view-dialog {\n    max-width: calc(100vw - 24px);\n\n    .dialog-header {\n      padding: 14px 12px 14px 16px;\n    }\n\n    .dialog-content {\n      padding: 14px 14px 10px;\n\n      .form-grid {\n        grid-template-columns: 1fr;\n\n        .span-2 {\n          grid-column: 1;\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 14px 14px;\n      padding-bottom: max(14px, env(safe-area-inset-bottom, 0));\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .schedule-view-dialog {\n    max-width: calc(100vw - 16px);\n\n    .dialog-header {\n      padding: 12px 8px 12px 14px;\n    }\n\n    .dialog-content {\n      padding: 12px 12px 8px;\n    }\n\n    .dialog-actions {\n      padding: 12px 12px 14px;\n      padding-bottom: max(14px, env(safe-area-inset-bottom, 0));\n      gap: 10px;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .schedule-view-dialog,\n  .schedule-view-dialog .dialog-header,\n  .schedule-view-dialog .dialog-content,\n  .schedule-view-dialog .dialog-actions {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .schedule-view-dialog .dialog-actions {\n    background: #0f172a !important;\n  }\n\n  .schedule-view-dialog .dialog-title,\n  .schedule-view-dialog .lead,\n  .schedule-view-dialog .calendar-section-label,\n  .schedule-view-dialog .calendar-label,\n  .schedule-view-dialog .calendar-sublabel,\n  .schedule-view-dialog .close-button,\n  .schedule-view-dialog .close-button mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .schedule-view-dialog .content-title-block,\n  .schedule-view-dialog .calendar-option {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .schedule-view-dialog .calendar-option:active,\n  .schedule-view-dialog .calendar-option.active {\n    background: #273449 !important;\n  }\n\n  .schedule-view-dialog .cancel-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  /* ── mat-form-field outlined inputs — transparent fill so the dark bg\n     doesn't overflow the rounded outline border in dark mode ── */\n  ::ng-deep .schedule-view-dialog .mdc-text-field--outlined,\n  ::ng-deep .schedule-view-dialog .mdc-text-field--outlined:not(.mdc-text-field--disabled),\n  ::ng-deep .schedule-view-dialog .mat-mdc-text-field-wrapper,\n  ::ng-deep .schedule-view-dialog .mat-mdc-form-field,\n  ::ng-deep .schedule-view-dialog .mat-mdc-form-field-infix,\n  ::ng-deep .schedule-view-dialog .mat-mdc-form-field-flex {\n    background: transparent !important;\n    background-color: transparent !important;\n  }\n\n  ::ng-deep .schedule-view-dialog input,\n  ::ng-deep .schedule-view-dialog .mat-mdc-input-element,\n  ::ng-deep .schedule-view-dialog .mdc-text-field__input {\n    background: transparent !important;\n    background-color: transparent !important;\n    color: #f1f5f9 !important;\n    caret-color: #f1f5f9 !important;\n  }\n\n  ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__leading,\n  ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__notch,\n  ::ng-deep .schedule-view-dialog .mdc-text-field--outlined .mdc-notched-outline__trailing {\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  ::ng-deep .schedule-view-dialog .mdc-floating-label,\n  ::ng-deep .schedule-view-dialog .mat-mdc-floating-label {\n    color: #94a3b8 !important;\n  }\n\n  ::ng-deep .schedule-view-dialog .mdc-floating-label--float-above,\n  ::ng-deep .schedule-view-dialog .mat-mdc-floating-label--float-above {\n    color: #5ea1d8 !important;\n  }\n\n  ::ng-deep .schedule-view-dialog input::placeholder,\n  ::ng-deep .schedule-view-dialog .mat-mdc-input-element::placeholder {\n    color: #64748b !important;\n    opacity: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
